import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalizerDirective } from './directives/localizer.directive';
import { LocalizerPipe } from './pipes/localizer.pipe';

@NgModule({
  imports: [CommonModule, LocalizerDirective, LocalizerPipe],
  exports: [LocalizerDirective, LocalizerPipe],
})
export class LocalizerModule {}
